import React from 'react';

import { DetailsChildrenTab } from 'app/main/components/page-layouts';

import getKpisGoalsValuesTableColumns from '../KpisGoalsValuesTableColumns';
import type { KpisGoalsValuesAggregationType } from '../components/KpisUtils';

interface KpisGoalsValuesDetailsTabType {
	aggregation: KpisGoalsValuesAggregationType;
	refresh: boolean;
	updateRefresh: VoidFunction;
}

export default function KpisGoalsValuesDetailsTab(props: KpisGoalsValuesDetailsTabType) {
	return (
		<DetailsChildrenTab
			module="sys_kpis_goals_values"
			content={{
				type: 'table',
				getColumns: params => getKpisGoalsValuesTableColumns({ ...params, aggregation: props.aggregation })
			}}
			refresh={props.refresh}
			updateRefresh={props.updateRefresh}
			defaultFilters={[
				{
					filt_field: 'kpis_aggregation_module',
					filt_clause: 'equals',
					filt_value: props.aggregation.module
				},
				{
					filt_field: 'kgvl_aggregation_module_value',
					filt_clause: 'equals',
					filt_value: props.aggregation.value
				}
			]}
		/>
	);
}
